export const authApiEndpoints = {
  oneId: {
    getRedirectUrl: "/sso/auth/",
    authenticate: "/sso/callback/"
  }
}
